const items = [
  "Hunt Dhurandhar",
  "Recognition Grand Slam",
  "Crazy Sports",
  "Phish Dhurandhar",
  "Decision Dhurandhar",
  "Risk Dhurandhar",
  "Trust Dhurandhar",
  "Clue Dhurandhar",
  "Fact or Fake",
];

export default function Ticker() {
  const full = [...items, ...items, ...items];
  return (
    <div
      data-testid="ticker"
      className="border-y border-white/10 bg-black py-4 overflow-hidden relative"
    >
      <div className="marquee">
        {full.map((s, i) => (
          <span key={i} className="mx-8 font-mono text-xs uppercase tracking-[0.3em] text-neutral-500">
            <span className="text-[#dc2626] mr-3">◆</span>
            {s}
          </span>
        ))}
      </div>
    </div>
  );
}
